// extracted by mini-css-extract-plugin
export default {"todisBtnOutline":"Organizations_todisBtnOutline__rlePD"};